import { FunctionComponent, useMemo } from "react";
import { sortTeamScheduleActivities } from "../../../../services/schedule";
import { ActivityTile } from "../../../views/activity-tile/activity-tile";
import { ActivityInterface } from "../../../../interfaces/activity.interface";
import { TeamScheduleDate } from "../../../../interfaces/day.interface";

interface IDayPartActivitiesProps {
    day: TeamScheduleDate;
    handleClickTile: (activity: ActivityInterface) => void;
}
export const DayPartActivities: FunctionComponent<IDayPartActivitiesProps> = (
    { day, handleClickTile }: IDayPartActivitiesProps
) => {
    const sortedActivities = useMemo(() => {
        const sorted = [...day.activities].sort(sortTeamScheduleActivities);
        return sorted;
    }, [day.activities, day.date]);

    return (
        <td className="tile-td">
            <div className="tile-activities">
                {sortedActivities.map((activity, index) => (
                    <ActivityTile
                        index={index}
                        key={`activityTile-${activity.id}-${index}`}
                        handleClickTile={handleClickTile}
                        tileData={{ activity }}
                    />
                ))}
            </div>
        </td>
    );
};